module.exports = __webpack_public_path__ + "static/media/active_carousel.9cdf17f4.svg";